const Field = {
  props: {
    field: {
      type: Object
    },
    extendClass: {
      default: ''
    },
    message: {
      type: String,
      default: ''
    }
  },

  template: `
    <div class="form-field" :class='extendClass'>
      <div class="form-field-head">
        <div class="form-field-title">{{ field.title }}</div>
        <div class="form-field-description" v-if='field.description'>{{ field.description }}</div>
      </div>
      <div class="form-field-input-container">
        <div class="form-field-input">
          <slot name='input'></slot>
        </div>
        <div class="message">{{ message }}</div>
      </div>
    </div>
  `
};

export default Field;
